var map = {
	"./Java-Logo.png": 97,
	"./Scikit_learn_logo.svg.png": 98,
	"./address_image.svg": 99,
	"./animated_ashutosh.png": 100,
	"./animated_logo.svg": 101,
	"./aws.png": 102,
	"./blogs_image.svg": 103,
	"./bstack.png": 104,
	"./cisco.png": 105,
	"./cloud_infrastructure.svg": 106,
	"./codeInLogo.png": 107,
	"./contactMail.png": 108,
	"./coursera_logo.png": 109,
	"./data-analysislo.jpg": 110,
	"./data_science.svg": 111,
	"./deeplearning_ai_logo.png": 112,
	"./delhivery_logo.png": 113,
	"./developerActivity.svg": 114,
	"./devtern.png": 115,
	"./dgi.png": 116,
	"./djngo.png": 117,
	"./dsc_logo.png": 118,
	"./education.svg": 119,
	"./experience.svg": 120,
	"./feelingProud.svg": 121,
	"./freecopy_logo.png": 122,
	"./fullstack.svg": 123,
	"./gcp_logo.png": 124,
	"./github_logo.png": 125,
	"./googleAssistant.jpg": 126,
	"./googleAssistant.svg": 127,
	"./google_logo.png": 128,
	"./ibm_logo.png": 129,
	"./iiitk_logo.png": 130,
	"./intel_logo.jpg": 131,
	"./iu_logo.png": 132,
	"./jsFramework.svg": 133,
	"./lamma.png": 134,
	"./legato_logo.png": 135,
	"./manOnTable.svg": 136,
	"./microsoft_logo.png": 137,
	"./ml.png": 138,
	"./mozilla_logo.png": 139,
	"./muffito_logo.png": 140,
	"./nextuLogo.jpg": 141,
	"./nptel_logo.png": 142,
	"./onelogica.png": 143,
	"./opencv_logo.png": 144,
	"./portfolio.gif": 145,
	"./programmer.svg": 146,
	"./projects_image.svg": 147,
	"./pwa.png": 148,
	"./pypng.png": 149,
	"./saayaHealthLogo.png": 150,
	"./stanford_logo.png": 151,
	"./talksCardBack.svg": 152,
	"./talksCardBackAlt.svg": 153,
	"./tiktok_logo.png": 154,
	"./ui_ux_design.svg": 155,
	"./ui_ux_design.svg.png": 156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;